import { useState } from 'react'
import Papa from "papaparse";
import sha512 from 'js-sha512';
import './App.css';

function App() {
  const [credentials, setCredentials] = useState({
    org:'',
    user:'',
    key:'',
    id:'',
    consentDeclarations: [],
    rawData:[],
  })

  const [data, setData] = useState();
  const [uploaded, setUploaded] = useState(false);
  const [credentialsSet, setCredentialsSet] =useState(true)
  const [submitted, setSubmitted] = useState(true);
  const [csvURL, setCsvURL] = useState();

  let file = null;
  const handleChange = ({ target: { files } }) => {
    file = files[0];
  };

  const importCSV = async () => {
    try {
      let rawResults = [];
      Papa.parse(file, 
        {
          header: true,
          step: function(row) {
              rawResults.push(row.data);
          },
          complete: function() {
            setCredentials({...credentials,
                  rawData: rawResults,
                });
            setUploaded(true);
            setSubmitted(false);
        }})
    }
    catch(e) {
      console.log(e)
    }
  };

  const handleInputChange = (e) => {
    const target = e.target;
    const value = target.value;
    const name = target.name;
    setCredentials({...credentials,
      [name]: value
    });
  }

  const handleIdentifieres = () => {
    let indentifierArray = []
    for( const row of credentials.rawData) {
      for (const key in row) {
          indentifierArray.push(`&identifier[]=${sha512(row[key])}`);
      }
    }
    return indentifierArray.join('')
  }

  const refreshPage = ()=>{
    window.location.reload();
 }
  const dataFetcher = async (dataFetched=[], org="", user="", key="", selected, id="", identifiers="", page=1) => {
    try {
    let temporalData;
    let url;
    if (selected) {
      url = id ? `https://${org}.traqcloud.no/api/consents?consent_declaration_id=${id}${identifiers}?format=json&page=${page}&per_page=1000` :
      `https://${org}.traqcloud.no/api/consents?${identifiers}?format=json&page=${page}&per_page=1000`;
    } else {
      url = `https://${org}.traqcloud.no/api/consent_declarations?&per_page=1000&page=${page}` 
    }
      temporalData = await (fetch(url,
      {method: 'GET',
       headers: {'Authorization': 'Basic ' + btoa(user + ":" + key),
       'Content-Type': 'application/json'
      }})
      .then(res => res.json()))
      .catch(error => console.log(error));
   dataFetched.push(temporalData)
   if(temporalData.meta.total_pages >  page) {
     await dataFetcher(dataFetched, org, user, key, selected, id, identifiers, (page + 1));
    } else {
     return dataFetched;
   }
   return dataFetched
  } catch(error) {
    console.log(error);
  }
  }

  const submitCredentials = async ({org, user, key}, e) => {
    e.preventDefault();
    let dataFetched = []
    await (dataFetcher(dataFetched, org, user, key, false));
    const sortedData = dataFetched
        .map(row => row.data)
        .flat(1)
        .sort((a,b) =>new Date(b.attributes.date).getTime() -new Date(a.attributes.date).getTime());
    setCredentials({...credentials,
      consentDeclarations: sortedData
    });
    setSubmitted(true)
    setCredentialsSet(false);
  }

  const submit = async ({org, user, key, id}, e) => {
    try {
      e.preventDefault();
      let dataFetched = []
      const identifiers = handleIdentifieres();
      await (dataFetcher(dataFetched, org, user, key, true, id, identifiers))
      const sortedData = dataFetched
        .map(row => row.data)
        .flat(1)
        .sort((a,b) =>new Date(b.attributes.date).getTime() -new Date(a.attributes.date).getTime());
      const filteredData = sortedData.filter((item, index) => 
        sortedData.findIndex(i => 
          (i.attributes.identifier === item.attributes.identifier) && (i.relationships.consent_declaration.data.id === item.relationships.consent_declaration.data.id) ) === index);  
/*      
// This would display only the ones that have a consent valid or invalid, not everyone from the csv data provided 
      const displayData = filteredData.map(row => {
        let displayRow ;
        console.log(credentials.rawData)
        for (const consent of credentials.rawData) {
          for(const identifier in consent) {
            if(row.attributes.identifier === sha512(consent[identifier])) {
              displayRow = {...consent};
              displayRow.date = new Date(row.attributes.date);
              displayRow.title = row.attributes.subject;
              displayRow.consent = row.attributes.type;
              displayRow.valid_until = new Date(row.attributes.valid_until).toLocaleDateString();
            }
          }
        }
        return displayRow
      })
      .filter(dataRow => dataRow) */

// This will display everyone from the csv data provided, giving type:invalid to the ones with no consents
      const displayData = await credentials.rawData.map(row => {
        let displayRow;
        for (const key in row) {
          for (const consent of filteredData) {
            if(consent.attributes.identifier === sha512(row[key])) {
              if(!displayRow) {
                displayRow= [];
              }
              let consentDeclaration = credentials.consentDeclarations.filter(cd => cd.id === consent.relationships.consent_declaration.data.id)
              let displayRowArray = {...row};
              displayRowArray.date = new Date(consent.attributes.date);
              displayRowArray.title = consentDeclaration[0].attributes.title;
              displayRowArray.consent = consent.attributes.type;
              displayRowArray.valid_until = new Date(consent.attributes.valid_until).toLocaleDateString();
              displayRow.push(displayRowArray)
            }
          }
        }
        if(!displayRow) {
          displayRow = {...row};
          displayRow.date = new Date()
          displayRow.consent = "No consent";
        }
        return displayRow;
      })
      .flat(1)
      .sort((a,b) => b.date.getTime() -a.date.getTime())
      .map(row => {
        row.date = row.date.toLocaleDateString()
        return row
      })

      setData(displayData);
      setSubmitted(true);
      let csv = Papa.unparse(displayData);
      const csvData = new Blob([csv], {type: 'text/csv;charset=utf-8;'}); 
      setCsvURL(window.URL.createObjectURL(csvData));
      return displayData;
    } catch(error) {
      console.log(error);
    }
  }
  
  return (
    <div className="App">
      <header className="App-header">
        <p>Traq Data Checker</p>
      <button className="button-standard restart" onClick={refreshPage}>Restart</button>
      </header>
      <main>
      {!uploaded &&(
      <div>
        <label className="button-standard upload">
          <input type="file" accept=".csv" onChange={handleChange}/>
        </label>
        <button className="button-standard" onClick={importCSV}>Upload File</button>
      </div>
      )}
        {!submitted &&(
        <form onSubmit={(e) =>submitCredentials(credentials, e)}>
         <fieldset>
           <label>
             <p>Domain Name:</p>
              <input type="text" name="org" value={credentials.org} onChange={handleInputChange}/>
                   </label>
           <label>
             <p>User Name:</p>
              <input type="text" name="user" value={credentials.user} onChange={handleInputChange}/>
                   </label>
           <label>
             <p>API Key:</p>
              <input type="password" name="key" value={credentials.key} onChange={handleInputChange}/>
                   </label>
         </fieldset>
            <input className="button-standard" type="submit" value="Submit" />
        </form>)}

        {!credentialsSet && (
            <form onSubmit={(e) =>submit(credentials, e)}>
            <fieldset>
              <label>
              Select one Consent Declaration or all of them:
              <select value={credentials.id} name="id" onChange={handleInputChange}>
              <option value="">All</option>
              {credentials.consentDeclarations.map((consentDeclaration, i) => (
                <option key={i} value={consentDeclaration.id}>{consentDeclaration.attributes.title}</option>
                ))}
                </select>
                </label>
            </fieldset>
              <input className="button-standard" type="submit" value="Submit" />
              </form>
        )}
        

      {data && (
        <section>
          {csvURL && (
          <a className="button-standard download" href={csvURL} download="data">Download data to CSV file</a>)}
          {data.map((row, i) => (
          <div className="displayed-data" key={i}>
            {Object.keys(row).map((tag, i) =>{
                return row[tag] && (
                <div key={i} className="displayed-block">  
                  <p className="tags" >{tag}: </p>
                  <p>{row[tag]}</p>
                </div>)
                }
                )}
          </div>
          ))}
        </section>
      )}
      </main>
    </div>
  );
}

export default App;
